import { Box, Typography } from "@mui/material";
import ProgressCircle from "../ProgressCircle";
import GeographyChart from "../../components/GeographyChart";
import BarChart from "../../components/BarChart";

const DashboardThirdRow = ({ colors }) => {
  return (
    <>
      {/* Campaign */}
      <Box
        gridColumn="span 4"
        gridRow="span 2"
        backgroundColor={colors.primary[400]}
        color={colors.primary[100]}
        p="30px"
      >
        <Typography variant="h5" fontWeight="600" color="text.primary">
          Campaign
        </Typography>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          mt="25px"
        >
          <ProgressCircle size="125" />
          <Typography
            variant="h5"
            color={colors.greenAccent[500]}
            sx={{ mt: "15px" }}
          >
            $48,352 revenue generated
          </Typography>
          <Typography>Includes extra misc expenditures and costs</Typography>
        </Box>
      </Box>

      {/* Sales Quantity */}
      <Box
        gridColumn="span 4"
        gridRow="span 2"
        backgroundColor={colors.primary[400]}
        color={colors.primary[100]}
      >
        <Typography
          variant="h5"
          fontWeight="600"
           color="text.primary"
          sx={{ padding: "30px 30px 0 30px" }}
        >
          Sales Quantity
        </Typography>
        <Box height="250px" mt="-20px">
          <BarChart isDashboard={true} />
        </Box>
      </Box>

      {/* Geography Based Traffic */}
      <Box
        gridColumn="span 4"
        gridRow="span 2"
        backgroundColor={colors.primary[400]}
        color={colors.primary[100]}
        padding="30px"
      >
        <Typography variant="h5" fontWeight="600" color="text.primary" sx={{ marginBottom: "15px" }}>
          Geography Based Traffic
        </Typography>
        <Box height="200px">
          <GeographyChart isDashboard={true} />
        </Box>
      </Box>
    </>
  );
};

export default DashboardThirdRow;
